import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import EmploymentType from '../../Ancillary/EmploymentType/views/EmploymentType';
import Documentations from '../../Ancillary/Documentations/views/Documentations';
import { useTheme } from "@mui/material/styles";
// import AtsDesignation from '../../ATS/views/Ancillary/AtsDesignation';

const AtsOnboarding = ({ accordian }) => {
    const theme = useTheme()
    const [expanded, setExpanded] = useState(accordian)
    // const { ats_designation_options } = useSelector(state => state?.AtsReducer?.AtsDesignationReducer);
    const { employment_type_options } = useSelector(state => state?.AncillaryReducer?.EmploymentTypeReducer);
    const { documentations_options } = useSelector(state => state.AncillaryReducer?.DocumentationsReducer);

    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    const values = [
        // { name: "Designation", comp: <AtsDesignation />, count: ats_designation_options?.length || 0 },
        { name: "Employment Type", comp: <EmploymentType />, count: employment_type_options?.length || 0 },
        { name: "Documentations", comp: <Documentations />, count: documentations_options?.length || 0 },
    ]

    const actionSummaryStyle = {
        minHeight: 50,
        maxHeight: 50,
        borderRadius: "10px 10px 0px 0px",
        // backgroundColor: '#a5a5a5',
        '&.Mui-expanded': {
            minHeight: 50,
            maxHeight: 50,
            backgroundColor: theme?.palette?.primary?.dark,
            color: "white",
        }
    }

    return (
        <div style={{ padding: "10px 0px" }}>
            {values.map((value, id) => {
                return (
                    <Accordion key={id} expanded={expanded === `${value.name}`} onChange={handleChange(`${value.name}`)} sx={{ borderRadius: "10px" }}>
                        <AccordionSummary sx={actionSummaryStyle}
                            expandIcon={<KeyboardArrowDownIcon />}
                            id='controlled-panel-header-1'
                            aria-controls='controlled-panel-content-1'
                        >
                            <Typography sx={{ color: theme.palette.primary.contrastText }} variant='body1' fontWeight={600}>{value.name} ({value.count})</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {value.comp}
                        </AccordionDetails>
                    </Accordion>
                )
            })}
        </div>
    );
}

export default AtsOnboarding;
